import _ from 'lodash';
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { Row } from '@/main/utils/table';
import { UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';
import { dataMapper } from '@/main/utils/dataMapper';
import { Status } from '@/main/store/@types/page';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { listMutations } from './types';

export type Interval<T> = { Od: T | null, Do: T | null };

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ZakazkaDruh: [],
		StatId: [],
		ZakaznikSk: [],
		KategOzn: [],
		ProvozovnaId: [],
		VyrobekvozOzn: [],
		Typkod: [],
		Tablpozice: [],
		GarPzn: [],
	},
	filter: {
		FirmaPrijmeni: null as string | null,
		FirmaPrijmeniSubstr: 0,
		Jmeno: null as string | null,
		Obec: null as string | null,
		IcoNr: null as string | null,
		Kns: null as string | null,
		ZakaznikDruh: null as number | null,
		Ulice: null as string | null,
		PscNr: null as string | null,
		StatId: [],
		EMailAdresa: null as string | null,
		NarodeniDatOd: null as Date | null,
		NarodeniDatDo: null as Date | null,
		ZakaznikSk: [],
		KategOzn: [],
		VstupDatOd: null as Date | null,
		VstupDatDo: null as Date | null,
		ProvozovnaId: [],
		SplatnostInlOd: null as Date | null,
		SplatnostInlDo: null as Date | null,
		PojistovnaPrp: null as boolean | null,
		NeplaticPrp: null as boolean | null,
		LeasfmaPrp: null as boolean | null,
		PrevodMaxOd: null as Date | null,
		PrevodMaxDo: null as Date | null,
		JinyplatceId: null as number | null,
		PracovnikId: null as number | null,
		ProdejDatOd: null as Date | null,
		ProdejDatDo: null as Date | null,
		PosledniServisDatOd: null as Date | null,
		PosledniServisDatDo: null as Date | null,
		NavsetvaServisDatOd: null as Date | null,
		NavsetvaServisDatDo: null as Date | null,
		ObdobiObradDatOd: null as Date | null,
		ObdobiObradDatDo: null as Date | null,
		NdObratSumOd: null as number | null,
		NdObratSumDo: null as number | null,
		SluzbyObratSumOd: null as number | null,
		SluzbyObratSumDo: null as number | null,
		Vozidlo: {
			Spz: null as string | null,
			SpzSubstr: 0,
			KaroserieNr: null as string | null,
			KaroserieNrSubstr: 0,
			PosledniVozidlo: false,
			VyrobekvozOzn: null as string | null,
			Typkod: null as string | null,
			Tablpozice: null as string | null,
			MotorNr: null as string | null,
			MotorNrSubstr: 0,
			MotorKod: null as string | null,
			MotorKodSubstr: 0,
			PrevodKod: null as string | null,
			PrevodKodSubstr: 0,
			ProdejDatOd: null as Date | null,
			ProdejDatDo: null as Date | null,
			ModelRokOd: null as Date | null,
			ModelRokDo: null as Date | null,
			DoplnekMk: null as string | null,
			LeaszakaznikId: null as number | null,
			LeassmlouNr: null as string | null,
			Leaspodminky: null as string | null,
			LeasKonecDatOd: null as Date | null,
			LeasKonecDatDo: null as Date | null,
			LeasPlatcePrp: null as boolean | null,
			PojistovnaId: null as number | null,
			PojistsmlNr: null as string | null,
			DokladDatKonecOd: null as Date | null,
			DokladDatKonecDo: null as Date | null,
			GarKonecDatOd: null as Date | null,
			GarKonecDatDo: null as Date | null,
			DokladDatVstupOd: null as Date | null,
			DokladDatVstupDo: null as Date | null,
			OpravaObratOd: null as number | null,
			OpravaObratDo: null as number | null,
			GarPzn: null as number | null,
			ProdejzdePrp: null as boolean | null,
			BarvaText: null as string | null,
			StkDatOd: null as Date | null,
			StkDatDo: null as Date | null,
			StkplatDatOd: null as Date | null,
			StkplatDatDo: null as Date | null,
			EmiseDatOd: null as Date | null,
			EmiseDatDo: null as Date | null,
			EmiseosvNr: null as number | null,
			VstupDatOd: null as Date | null,
			VstupDatDo: null as Date | null,
			ProdejceprId: null as number | null,
			SkodaNr: null as string | null,
			TypSda: null as number | null,
			SdaVin: [] as Interval<string>[],
		},
	},
	tableSetting: {
		columnSettings: {
		},
	},
	rowDetail: null,
	localState: {
		multipleSelection: [] as Row[],
		JinyplatceIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		PracovnikIdText: null as string | null,
		LeaszakaznikIdText: null as string | null,
		PojistovnaIdText: null as string | null,
		ProdejceprIdText: null as string | null,
		enableSdaTyp: false,
	},
	extraActions: {
	},
	extraMutations: {
		[listMutations.LEASING_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.Vozidlo.LeaszakaznikId = data.value;
			state.localState.LeaszakaznikIdText = data.text;
		},
		[listMutations.POISTOVNA_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.Vozidlo.PojistovnaId = data.value;
			state.localState.PojistovnaIdText = data.text;
		},
		[listMutations.PRODEJCEPR_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.Vozidlo.ProdejceprId = data.value;
			state.localState.ProdejceprIdText = data.text;
		},
		[UPDATE_BASIC_FILTER](state, data: any) {
			if (!state.filter) throw Error('Undefined Filter');
			data.DropDownList && (state.dropdownList = { ...(state.dropdownList ?? {}), ...data.DropDownList });
			if (data.ValidationRules) {
				if (!_.isEmpty(data.ValidationRules)) {
					state.validationRules = data.ValidationRules;
				}
				delete data.ValidationRules;
			}

			if (data.Filter.Vozidlo) {
				delete data.Filter.Vozidlo.SdaVin;
				dataMapper(state.filter.Vozidlo, data.Filter.Vozidlo);
				delete data.Filter.Vozidlo;
			}
			dataMapper(state.filter, data.Filter);
			state.status = Status.ok;
			state.table.emptyTextKey = 'TableMsgRunSearch';
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
